import script from "./InputMarkdown.vue?vue&type=script&setup=true&lang=js"
export * from "./InputMarkdown.vue?vue&type=script&setup=true&lang=js"

import "./InputMarkdown.vue?vue&type=style&index=0&id=195e7419&lang=scss"

const __exports__ = script;

export default __exports__